/**
 * Created by matos on 12/07/2017.
 */
export function GeneralSocketSystem(options = {}) {

	/**
	 * General socket system, is a socket manager for simple actions.
	 * Basically it has all generic socket stuff, like a keep alive timer and ping test
	 * so the backend knows we are still connected (it has a call back for that as well so any
	 * major functionality that you need to make sure the user is alive on the channel you can use that)
	 */

	let socket_tester = {
		timer:null,

		here:function (){
			axios.post('/sockets/here')
				.then(function (response){
					if (!response.data.success){
						if (response.data.time_out){
							clearInterval(window.GS.timer);
						}
						else {
							toastr.warning('Something seams to be wrong with the server...');
						}
					}
				})
				.catch(function (){
					//Something happen - Trying again
					setTimeout(function () {
						axios. post('/sockets/here')
							.then(function (response){
								toastr.success('Connection reestablished');
							})
							.catch(function (){
								//Nope.. still no connection, reloading the page
								window.location.reload();
							})
					}, 5000);


					//Notify the user
					toastr.error('Lost connection to the server');
				})
		},

		init: function (options) {
			let
				isTabActive = true,
				user_id = $(document.body).data('user_id');

			if (user_id > 0) {

				window.onfocus = function () {
					isTabActive = true;
				};
				window.onblur = function () {
					isTabActive = false;
				};

				window.CoreEcho.join(options.channel + "." + user_id)
					.listen('.__alive', function (e) {
						axios.post(e.url, {token: e.token})
					})
					.listen('.get_route', function (e){
						axios.post(e.url, {
							token: e.token,
							route: {
								name: $(document.body).data('route-name'),
								params: $(document.body).data('route-params')
							}
						})
					})
					.listen('.is_in_url', function (e){
						if (e.target_url === window.location.href){
							setTimeout(function (){
								axios.post(e.url, {
									token: e.token,
									isInUrl: true,
									page_key: e.page_key
								});
							}, 350);
						}
						else {
							if (isTabActive){
								//let's wait for a second
								setTimeout(function (){
									axios.post(e.url, {
										token: e.token,
										isInUrl: false,
										page_key: e.page_key
									});
								}, 1000);
							}
						}
					});

				return {
					timer: setInterval(this.here, options.updateTimeout),
					running: true
				}
			}
			else {
				return {
					timer: null,
					running: false
				}
			}
		}
	};

	return  socket_tester.init(options);
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/notifications/GeneralSocketSystem.js